import { persistentMap } from '@nanostores/persistent';

export type AI_Model = 'dev-ai-model' | 'prod-ai-model' | 'dev-mock-ai-model' | 'dev-better' | 'custom';

export type LLM_Provider = 'aws' | 'gcp';

import type { Framework, Language } from '~/lib/stores/techStackSelection';

type projectSource = 'github' | 'community_template' | 'alpha_template';

export type SelectionValues = {
  projectName: string;
  temporaryProjectRules: string;
  netlifyAccessToken: string;
  netlifySiteId: string;
  netlifySiteUrl: string;
  githubAccessToken: string;
  aiModel: AI_Model;
  llmProvider: LLM_Provider;
  framework: Framework;
  language: Language;
  presetModalView: 'presets' | 'custom';
  rememberCustomStack: 'true' | 'false';
  hasInteractedWithModal: 'true' | 'false';
  projectSource?: projectSource;
  templateId?: string;
  templateName?: string;
};

export const selectionStore = persistentMap<SelectionValues>('selection', {
  projectName: 'Untitled',
  aiModel: 'dev-mock-ai-model',
  llmProvider: 'aws',
  temporaryProjectRules: '',
  githubAccessToken: '',
  netlifyAccessToken: '',
  netlifySiteId: '',
  netlifySiteUrl: '',
  framework: 'react_tailwind',
  language: 'ts',
  presetModalView: 'presets',
  rememberCustomStack: 'true',
  hasInteractedWithModal: 'false',
  projectSource: undefined,
  templateId: undefined,
  templateName: undefined,
});
